import { ColorPicker } from 'antd';
import '../../settings-page.scss';
import { SettingsHeader } from '../../../../components/layout/settings-header/settings-header';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SettingsRow } from '../settings-row/settings-row';
import { BookrWpOptions } from '../../../../core/models/bookr-wp-options';

type CustomizeSettingsProps = {
	bookrWpOptions?: BookrWpOptions;
	onClickSave: () => void;
	onChange: (bookrWpOptions: BookrWpOptions) => void;
};

export const CustomizeSettings: React.FC<CustomizeSettingsProps> = ({ bookrWpOptions, onClickSave, onChange }) => {
	const { t } = useTranslation();

	const [primaryColor, setPrimaryColor] = useState<string>(window.bookrPluginData.primaryColor);

	useEffect(() => {
		if (!bookrWpOptions) return;

		const updateBookrOptions: BookrWpOptions = {
			...bookrWpOptions,
			primaryColor: `#${primaryColor}`,
		};

		onChange(updateBookrOptions);
	}, [primaryColor]);

	return (
		<>
			<SettingsHeader title={t('backEnd.settings.customize.title')} onClickSave={onClickSave} />

			<SettingsRow title={t('backEnd.settings.customize.primaryColor')}>
				<ColorPicker defaultValue={primaryColor} showText format={'hex'} onChangeComplete={(value) => setPrimaryColor(value.toHex())} />
			</SettingsRow>
		</>
	);
};
